import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetVoProRegDocQueryQueryVariables = Types.Exact<{
  queryArgs: Types.QueryArgsInput;
  isAdmin: Types.Scalars['Boolean'];
}>;


export type GetVoProRegDocQueryQuery = { __typename?: 'Query', voProRegDocQuery: { __typename?: 'RegDocInfinityResults', regDocIds: Array<string>, regDocFilterOptions: { __typename?: 'RegDocFilterOptions', modelYearOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, statusOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, workFlowOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, regulationOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, marketOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, mainKeywordOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, keywordOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, contactPersonOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, disassemblyStatusOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, driveVariantOptions?: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, vehicleCategoryOptions?: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, vexClusterOptions?: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }> }, regDocsBatch: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, modifiedAt?: any | null, modelYear?: number | null, dateEffective?: any | null, dateNewTypes?: any | null, dateNewRegistration?: any | null, comprehensive?: any | null, status: Types.RegulatoryDocumentStatus, numberOfSegments?: number, disassemblyStatus: Types.RegulatoryDocumentDisassemblyStatus, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus, clearingTimestamp?: any | null }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', name: string }>, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', name: string }>, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null }>, phaseOut: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }>, phaseIn: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }>, contactPersons: Array<{ __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }>, driveVariants?: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, vehicleCategories?: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, vexClusters?: Array<{ __typename?: 'VexCluster', id: string, name: string }>, regulation?: { __typename?: 'Regulation', id: string, regulationNumber: string, name: string } | null }> } };

export type GetVoProRegDocNextQueryVariables = Types.Exact<{
  nextArgs: Types.NextArgsInput;
  isAdmin: Types.Scalars['Boolean'];
}>;


export type GetVoProRegDocNextQuery = { __typename?: 'Query', voProRegDocNext: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, modifiedAt?: any | null, modelYear?: number | null, dateEffective?: any | null, dateNewTypes?: any | null, dateNewRegistration?: any | null, comprehensive?: any | null, status: Types.RegulatoryDocumentStatus, numberOfSegments?: number, disassemblyStatus: Types.RegulatoryDocumentDisassemblyStatus, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus, clearingTimestamp?: any | null }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', name: string }>, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', name: string }>, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null }>, phaseOut: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }>, phaseIn: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }>, contactPersons: Array<{ __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }>, driveVariants?: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, vehicleCategories?: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, vexClusters?: Array<{ __typename?: 'VexCluster', id: string, name: string }>, regulation?: { __typename?: 'Regulation', id: string, regulationNumber: string, name: string } | null }> };

export type GetVoProSummaryQueryVariables = Types.Exact<{
  nextArgs: Types.NextArgsInput;
}>;


export type GetVoProSummaryQuery = { __typename?: 'Query', voProRegDocNext: Array<{ __typename?: 'RegulatoryDocument', id: string, summary?: string | null, changeHistoryAuditLogs: Array<{ __typename?: 'AuditLog', createdAt: any, change: { __typename?: 'AuditLogChange', value?: any | null } }> }> };

export type GetVoProRegDocSortOrderQueryVariables = Types.Exact<{
  sortArgs: Types.SortArgsInput;
}>;


export type GetVoProRegDocSortOrderQuery = { __typename?: 'Query', voProRegDocSortOrder: Array<string> };


export const GetVoProRegDocQueryDocument = gql`
    query GetVoProRegDocQuery($queryArgs: QueryArgsInput!, $isAdmin: Boolean!) {
  voProRegDocQuery(queryArgs: $queryArgs) {
    regDocIds
    regDocFilterOptions {
      modelYearOptions {
        optionKey
        name
      }
      statusOptions {
        optionKey
        name
      }
      workFlowOptions {
        optionKey
        name
      }
      regulationOptions {
        optionKey
        name
      }
      marketOptions {
        optionKey
        name
      }
      mainKeywordOptions {
        optionKey
        name
      }
      keywordOptions {
        optionKey
        name
      }
      contactPersonOptions {
        optionKey
        name
      }
      disassemblyStatusOptions {
        optionKey
        name
      }
      driveVariantOptions @include(if: $isAdmin) {
        optionKey
        name
      }
      vehicleCategoryOptions @include(if: $isAdmin) {
        optionKey
        name
      }
      vexClusterOptions @include(if: $isAdmin) {
        optionKey
        name
      }
    }
    regDocsBatch {
      id
      name
      workflow {
        status
      }
      modifiedAt
      modelYear
      markets {
        id
        name
      }
      mainKeywords {
        id
        name
        vexClusters {
          id
          name
        }
        vkos {
          name
        }
        descriptions {
          lang
          translation
        }
      }
      keywords {
        id
        name
        vexClusters {
          id
          name
        }
        vkos {
          name
        }
        descriptions {
          lang
          translation
        }
      }
      phaseOut {
        date
        status
      }
      phaseIn {
        date
        status
      }
      contactPersons {
        givenName
        id
        mail
        name
        surname
        userPrincipalName
      }
      dateEffective
      dateNewTypes
      dateNewRegistration
      comprehensive
      status
      numberOfSegments @include(if: $isAdmin)
      disassemblyStatus
      driveVariants @include(if: $isAdmin) {
        id
        name
      }
      vehicleCategories @include(if: $isAdmin) {
        id
        name
      }
      vexClusters @include(if: $isAdmin) {
        id
        name
      }
      workflow {
        clearingTimestamp
      }
      regulation {
        id
        regulationNumber
        name
      }
    }
  }
}
    `;

/**
 * __useGetVoProRegDocQueryQuery__
 *
 * To run a query within a React component, call `useGetVoProRegDocQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoProRegDocQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoProRegDocQueryQuery({
 *   variables: {
 *      queryArgs: // value for 'queryArgs'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useGetVoProRegDocQueryQuery(baseOptions: Apollo.QueryHookOptions<GetVoProRegDocQueryQuery, GetVoProRegDocQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoProRegDocQueryQuery, GetVoProRegDocQueryQueryVariables>(GetVoProRegDocQueryDocument, options);
      }
export function useGetVoProRegDocQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoProRegDocQueryQuery, GetVoProRegDocQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoProRegDocQueryQuery, GetVoProRegDocQueryQueryVariables>(GetVoProRegDocQueryDocument, options);
        }
export type GetVoProRegDocQueryQueryHookResult = ReturnType<typeof useGetVoProRegDocQueryQuery>;
export type GetVoProRegDocQueryLazyQueryHookResult = ReturnType<typeof useGetVoProRegDocQueryLazyQuery>;
export type GetVoProRegDocQueryQueryResult = Apollo.QueryResult<GetVoProRegDocQueryQuery, GetVoProRegDocQueryQueryVariables>;
export const GetVoProRegDocNextDocument = gql`
    query GetVoProRegDocNext($nextArgs: NextArgsInput!, $isAdmin: Boolean!) {
  voProRegDocNext(nextArgs: $nextArgs) {
    id
    name
    workflow {
      status
    }
    modifiedAt
    modelYear
    markets {
      id
      name
    }
    mainKeywords {
      id
      name
      vexClusters {
        id
        name
      }
      vkos {
        name
      }
      descriptions {
        lang
        translation
      }
    }
    keywords {
      id
      name
      vexClusters {
        id
        name
      }
      vkos {
        name
      }
      descriptions {
        lang
        translation
      }
    }
    phaseOut {
      date
      status
    }
    phaseIn {
      date
      status
    }
    contactPersons {
      givenName
      id
      mail
      name
      surname
      userPrincipalName
    }
    dateEffective
    dateNewTypes
    dateNewRegistration
    comprehensive
    status
    numberOfSegments @include(if: $isAdmin)
    disassemblyStatus
    driveVariants @include(if: $isAdmin) {
      id
      name
    }
    vehicleCategories @include(if: $isAdmin) {
      id
      name
    }
    vexClusters @include(if: $isAdmin) {
      id
      name
    }
    workflow {
      clearingTimestamp
    }
    regulation {
      id
      regulationNumber
      name
    }
  }
}
    `;

/**
 * __useGetVoProRegDocNextQuery__
 *
 * To run a query within a React component, call `useGetVoProRegDocNextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoProRegDocNextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoProRegDocNextQuery({
 *   variables: {
 *      nextArgs: // value for 'nextArgs'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useGetVoProRegDocNextQuery(baseOptions: Apollo.QueryHookOptions<GetVoProRegDocNextQuery, GetVoProRegDocNextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoProRegDocNextQuery, GetVoProRegDocNextQueryVariables>(GetVoProRegDocNextDocument, options);
      }
export function useGetVoProRegDocNextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoProRegDocNextQuery, GetVoProRegDocNextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoProRegDocNextQuery, GetVoProRegDocNextQueryVariables>(GetVoProRegDocNextDocument, options);
        }
export type GetVoProRegDocNextQueryHookResult = ReturnType<typeof useGetVoProRegDocNextQuery>;
export type GetVoProRegDocNextLazyQueryHookResult = ReturnType<typeof useGetVoProRegDocNextLazyQuery>;
export type GetVoProRegDocNextQueryResult = Apollo.QueryResult<GetVoProRegDocNextQuery, GetVoProRegDocNextQueryVariables>;
export const GetVoProSummaryDocument = gql`
    query GetVoProSummary($nextArgs: NextArgsInput!) {
  voProRegDocNext(nextArgs: $nextArgs) {
    id
    changeHistoryAuditLogs {
      createdAt
      change {
        value
      }
    }
    summary
  }
}
    `;

/**
 * __useGetVoProSummaryQuery__
 *
 * To run a query within a React component, call `useGetVoProSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoProSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoProSummaryQuery({
 *   variables: {
 *      nextArgs: // value for 'nextArgs'
 *   },
 * });
 */
export function useGetVoProSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetVoProSummaryQuery, GetVoProSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoProSummaryQuery, GetVoProSummaryQueryVariables>(GetVoProSummaryDocument, options);
      }
export function useGetVoProSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoProSummaryQuery, GetVoProSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoProSummaryQuery, GetVoProSummaryQueryVariables>(GetVoProSummaryDocument, options);
        }
export type GetVoProSummaryQueryHookResult = ReturnType<typeof useGetVoProSummaryQuery>;
export type GetVoProSummaryLazyQueryHookResult = ReturnType<typeof useGetVoProSummaryLazyQuery>;
export type GetVoProSummaryQueryResult = Apollo.QueryResult<GetVoProSummaryQuery, GetVoProSummaryQueryVariables>;
export const GetVoProRegDocSortOrderDocument = gql`
    query GetVoProRegDocSortOrder($sortArgs: SortArgsInput!) {
  voProRegDocSortOrder(sortArgs: $sortArgs)
}
    `;

/**
 * __useGetVoProRegDocSortOrderQuery__
 *
 * To run a query within a React component, call `useGetVoProRegDocSortOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoProRegDocSortOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoProRegDocSortOrderQuery({
 *   variables: {
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useGetVoProRegDocSortOrderQuery(baseOptions: Apollo.QueryHookOptions<GetVoProRegDocSortOrderQuery, GetVoProRegDocSortOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoProRegDocSortOrderQuery, GetVoProRegDocSortOrderQueryVariables>(GetVoProRegDocSortOrderDocument, options);
      }
export function useGetVoProRegDocSortOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoProRegDocSortOrderQuery, GetVoProRegDocSortOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoProRegDocSortOrderQuery, GetVoProRegDocSortOrderQueryVariables>(GetVoProRegDocSortOrderDocument, options);
        }
export type GetVoProRegDocSortOrderQueryHookResult = ReturnType<typeof useGetVoProRegDocSortOrderQuery>;
export type GetVoProRegDocSortOrderLazyQueryHookResult = ReturnType<typeof useGetVoProRegDocSortOrderLazyQuery>;
export type GetVoProRegDocSortOrderQueryResult = Apollo.QueryResult<GetVoProRegDocSortOrderQuery, GetVoProRegDocSortOrderQueryVariables>;